





















































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SheetListCondition, Sheet } from "../../modules/teacher/SheetList"
import { SearchCondition as SaitenListCondition } from "../../modules/teacher/SaitenList"


export interface Data {
  condition: SheetListCondition
  sheets: Sheet[]
  totalCount: number
  school_id: number
  fields: any[]
  errors: string[]
  isShow: boolean
  comboboxCourse: any[]
  comboboxCampus: any[]
  comboboxClassification: any[]
  comboboxSubject: any[]
  nendos: number[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.sheetListCondition,
      sheets: new Array<Sheet>(),
      totalCount: 0,
      school_id: context.root.$store.state.currentUser.school_id,
      fields: [
        {key: "sheet_code", label: "レポートID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "nendo", label: "年度", class: 'text-center b-table-th-td'},
        {key: "sheet_name", label: "レポート名", sortable: true, class: 'text-center b-table-th-td'},
        {key: "subject_name", label: "科目", sortable: true, class: 'text-center b-table-th-td'},
        {key: "course_name", label: "コース", sortable: true, class: 'text-center b-table-th-td'},
        {key: "campus_name", label: "キャンパス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "class_name", label: "クラス", sortable: true, class: 'text-center b-table-th-td'},
        {key: "student_count", label: "提出済枚数", sortable: true, class: 'text-center b-table-th-td'},
        {key: "mi_saiten_count", label: "未採点数", sortable: true, class: 'text-center b-table-th-td'},
        {key: "box", label: "BOX", class: 'text-center b-table-th-td'},
        {key: "submitted_at", label: "最新取込日", sortable: true, class: 'text-center b-table-th-td'},
        {key: "saiten", label: "採点", class: 'text-center b-table-th-td'},
        {key: "saiten_flg", label: "状態", class: 'text-center b-table-th-td'},
      ],
      errors: [],
      isShow: false,
      comboboxCourse: [],
      comboboxCampus: [],
      comboboxClassification: [],
      comboboxSubject: [],
      nendos: [],
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      state.errors = [];

      if(state.condition.nendo == null){
        state.errors.push("検索条件の年度が選択されていません。");
        return;
      }

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/sheet_list?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.sheets = response.data.sheets.map((x: any) => new Sheet(x));
        state.totalCount = state.sheets.length == 0 ? 0 : state.sheets[0].full_count;
        context.root.$store.commit("setSheetListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * admin権限で表示される学校プルダウン変更
     ******************************/

    const schoolChanged = async () => {

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/sheet_list/update_admin_school/${state.school_id}`).then(response => {
        context.root.$store.commit("setCurrentUserSchoolId", state.school_id);
        context.root.$store.commit("setCurrentUserSchoolOptions", response.data.school_options);
        context.root.$store.commit("setSheetListCondition", new SheetListCondition());
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 取込日を画面表示文言にコンバート
     ******************************/

    const convertSubmittedAt = (date: string) => {
      return date ? moment(date).format('Y年M月D日') : "-";
    };

    /******************************
     * 取込日を画面表示文言にコンバート
     ******************************/

    const convertAggregatedAt = (date: string) => {
      return date ? moment(date).format('Y年M月D日 HH時mm分') : "-";
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SheetListCondition();
      state.condition.nendo = Common.getNendo();
      setScorableCombobox();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 採点TOP(ペンシルアイコン)押下
     ******************************/

    const toSaitenList = (sheet: any) => {
      context.root.$store.commit("setSaitenListCondition", new SaitenListCondition());
      context.root.$store.commit("setSaitenTargetExamineeIds", []);
      context.root.$router.push(`/teacher_site/saiten_list/${sheet.id}`).catch(err => {});
    };

    /******************************
     * Webup画面へ遷移
     ******************************/

    const goWebupList = () => {
      context.root.$router.push(`/teacher_site/webup_list`);
    }

    /******************************
     * 画面リロード
     ******************************/

    const reload = () => {
      location.reload();
    };

    /******************************
     * コース・キャンパス・クラス・科目プルダウン取得
     ******************************/

    const setScorableCombobox = async () => {
      state.errors = [];
      await http.get(`/api/teacher/sheet_list/search_scorable_range/${state.condition.nendo}`).then(response => {
        state.comboboxCourse = Common.createComboboxOptions(response.data.scorable_courses, "course_code", "name", true);
        state.comboboxCampus = Common.createComboboxOptions(response.data.scorable_campuses, "campus_code", "name", true);
        state.comboboxClassification = Common.createComboboxOptions(response.data.scorable_classifications, "class_code", "name", true);
        state.comboboxSubject = Common.createComboboxOptions(response.data.scorable_subjects, "subject_code", "name", true);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsFilterMisaiten", null);
      context.root.$store.commit("setIsHeaderDisp", true);
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.Report);
      state.condition = context.root.$store.state.sheetListCondition;

      // 本日日付から年度を取得
      const nendo = Common.getNendo();

      // 年度プルダウンのoption設定
      for(let i = -3; i <= 2; i++){
        state.nendos.push(nendo + i);
      }

      if(!state.condition.nendo){
        // 検索条件.年度未設定の場合、今年度を設定
        state.condition.nendo = nendo;
      }

      await setScorableCombobox();
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      search,
      searchClick,
      convertSubmittedAt,
      convertAggregatedAt,
      clearCondition,
      changePage,
      toSaitenList,
      reload,
      schoolChanged,
      goWebupList,
      setScorableCombobox,
    }
  }
});
